"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOrganizationWithHubrise = exports.GeocodingProvider = exports.CurrencyCode = void 0;
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["CHF"] = "CHF";
    CurrencyCode["USD"] = "USD";
})(CurrencyCode || (exports.CurrencyCode = CurrencyCode = {}));
var GeocodingProvider;
(function (GeocodingProvider) {
    GeocodingProvider["MAPBOX"] = "mapbox";
    GeocodingProvider["GOOGLE"] = "google";
})(GeocodingProvider || (exports.GeocodingProvider = GeocodingProvider = {}));
const isOrganizationWithHubrise = (organization) => {
    return organization.externalApiConfig?.hubrise !== undefined;
};
exports.isOrganizationWithHubrise = isOrganizationWithHubrise;
